"use client";

import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { handleParse } from "@/lib/handleParse";
import { SpotlightSektion } from "@/types/page";
import { ArrowRightIcon } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import React from "react";

export default function SpotlightSectionLayout({
  content,
}: {
  content: SpotlightSektion;
}) {
  return (
    <section className="relative w-full h-[500px]">
      {content?.bild?.node?.mediaItemUrl && content?.bild?.node?.altText && (
        <Image
          src={content?.bild?.node?.mediaItemUrl}
          alt={content?.bild?.node?.altText}
          fill
          style={{ objectFit: "cover" }}
        />
      )}
      <div className="absolute inset-0 bg-overlay"></div>
      <div className="absolute z-20 top-0 left-0 bg-transparent text-white layout w-full h-full grid lg:grid-cols-2 ">
        <div className="flex flex-col justify-center gap-4">
          {content?.innehall?.text && handleParse(content.innehall.text)}

          {content?.innehall?.knapp?.uriurl &&
            content?.innehall?.knapp?.label &&
            content.innehall.knapp.uriurl.trim() !== "" &&
            content.innehall.knapp.label.trim() !== "" &&
            !content.innehall.knapp.uriurl.includes("http://") && (
              <div>
                {content.innehall.knapp.uriurl.includes("https://") ? (
                  <Button
                    effect="expandIcon"
                    icon={ArrowRightIcon}
                    iconPlacement="right"
                    asChild
                  >
                    {content.innehall.knapp.label}
                    <a
                      href={content.innehall.knapp.uriurl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {content.innehall.knapp.label}
                    </a>
                  </Button>
                ) : (
                  <Button
                    effect="expandIcon"
                    icon={ArrowRightIcon}
                    iconPlacement="right"
                    asChild
                  >
                    <Link href={content.innehall.knapp.uriurl}>
                      {content.innehall.knapp.label}
                    </Link>
                  </Button>
                )}
              </div>
            )}
        </div>
      </div>
    </section>
  );
}

export function SpotlightSectionSkeleton() {
  return (
    <section className="relative w-full h-[500px]">
      {/* Background image skeleton */}
      <Skeleton className="absolute inset-0 w-full h-full" />

      <div className="absolute z-20 top-0 left-0 bg-transparent text-white layout w-full h-full grid lg:grid-cols-2">
        <div className="flex flex-col justify-center gap-4">
          {/* Heading skeleton */}
          <Skeleton className="h-10 w-4/5 bg-white/30" />

          {/* Text content skeleton - multiple lines */}
          <div className="space-y-3">
            <Skeleton className="h-5 w-full bg-white/30" />
            <Skeleton className="h-5 w-5/6 bg-white/30" />
            <Skeleton className="h-5 w-4/5 bg-white/30" />
          </div>

          {/* Button skeleton */}
          <div className="mt-4">
            <Skeleton className="h-10 w-40 bg-white/30" />
          </div>
        </div>
      </div>
    </section>
  );
}
